import { PermissionService } from '@abp/ng.core';
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { PermissionConstants } from 'src/core/constants/permission.constant';

/**
 * Sends a user who may see the Wallboard tab but not the Overview tab straight to the Wallboard.
 *
 * `/dashboard` renders the Overview tab, and the two Dashboard permissions are independent siblings on the
 * server — a role can carry only `Dashboard.CanViewWallboard`. Without this, such a user following the
 * sidebar's Dashboard entry lands on a child route their permission does not cover and gets bounced out,
 * even though the page they are entitled to sits one tab away.
 *
 * Returns `true` in every other case so the `permissionGuard` behind it keeps deciding: a user with the
 * Overview permission is allowed through, and a user with neither is rejected the way every other route
 * rejects, rather than being redirected somewhere equally forbidden.
 */
export const dashboardOverviewRedirectGuard: CanActivateFn = (): boolean | UrlTree => {
  const permissionService = inject(PermissionService);

  if (permissionService.getGrantedPolicy(PermissionConstants.canViewTenantDashboard)) {
    return true;
  }

  if (permissionService.getGrantedPolicy(PermissionConstants.canViewWallboard)) {
    return inject(Router).parseUrl('/dashboard/wallboard');
  }

  return true;
};
